import BillingInformation from './BillingInformation.component';

export default BillingInformation;
